import axios from 'axios'
import role from '../../services/userRoles'

export default {
  state: {
    userName: '',
    role: '',
    response: {},
    error: null
  },
  mutations: {
    SET_USER_NAME_SUCCESS(state, payload) {
      state.userName = payload.fullName
      state.role = payload.role
      state.response = payload
      state.error = null
    },
    SET_USER_NAME_ERROR(state, error) {
      state.error = error
    },
    CLEAR_STATE(state) {
      state.userName = ''
      state.role = ''
      state.response = {}
      state.error = null
    }
  },
  actions: {
    GET_USER_INFO({ commit }) {
      const token = sessionStorage.getItem('token')
      return axios({
        method: 'GET',
        url: `/api/CustomerRegistration/GetCurrentEmployeeInfo/${token}`
      })
        .then(response => {
          commit('SET_USER_NAME_SUCCESS', response.data)
          role().setRole(response.data.role)
        })
        .catch(error => {
          commit('SET_USER_NAME_ERROR', error.response.data.message)
        })
    }
  }
}
